export const CoreDataDictionaryViewsName = 'CoreDataDictionaryViews';
